<template>
  <div v-if="isActive.createChoosePopup || isActive.createTaskPopup">
    <PopUp
      title="新增任務"
      :popUpActive="isActive.createChoosePopup"
      @click="$_onClosePopup('createChoosePopup')"
    >
      <LlTemplateButtonList
        noSearchBar
        :buttonList="createChooseList"
        @click="$_onChooseCreateType($event)"
      />
    </PopUp>
    <PopUp
      title="新增任務"
      :popUpActive="isActive.createTaskPopup"
      @click="$_onClosePopup('createTaskPopup')"
    >
      <LvDataTable
        v-if="isActive.createTaskPopup"
        :fetchUrl="_createTaskPopupConfig.fetchUrl"
        :setParams="_createTaskPopupConfig.setParams"
        :setListData="_createTaskPopupConfig.setListData"
        :columnHeader="_createTaskPopupConfig.columnHeader"
        :filterFieldTypes="_createTaskPopupConfig.filterFieldTypes"
        class="mt-20"
        @data-click="$_onClickTempToCreate($event)"
      />
    </PopUp>
  </div>
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import Spare_task from '@/spare/task';

export default {
  props: {
    createQuery: {
      type: Object,
    },
  },
  data() {
    return {
      isActive: {
        createChoosePopup: false,
        createTaskPopup: false,
      },
      createChooseList: Spare_task.createChooseList,
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    },
    _scopeReadTaskTemplate() {
      return S_scope.$_isAvailable(['task-factory-template-read']);
    },
    _createTaskPopupConfig() {
      const { fetchUrl, columnHeader, setListData, filterFieldTypes, setParams } =
        Spare_task.index.createTaskPopupConfig;
      return {
        fetchUrl: `factory/${this._currentFactoryId}/${fetchUrl}`,
        filterFieldTypes,
        columnHeader,
        setParams,
        setListData,
      };
    },
  },
  methods: {
    start() {
      if (!this._scopeReadTaskTemplate) {
        this.$_pushToCreatePage();
        return;
      }
      this.$_onOpenPopup('createChoosePopup');
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_pushToCreatePage(taskTemplateId) {
      this.$router.push({
        path: `/factory/${this._currentFactoryId}/task-create`,
        query: {
          ...this.createQuery,
          ...(taskTemplateId && { templateId: taskTemplateId }),
        },
      });
    },
    $_onChooseCreateType(type) {
      const chooseType = type.id;
      const actionList = {
        task: () => this.$_pushToCreatePage(),
        template: () => this.$_onOpenPopup('createTaskPopup'),
      };
      if (actionList[chooseType]) actionList[chooseType]();
      this.$_onClosePopup('createChoosePopup');
    },
    $_onClickTempToCreate($event) {
      this.$_pushToCreatePage($event.id);
    },
  },
};
</script>
